import { snakeToNormal } from "@/utils/stringUtils";

export const EventLogStatus = {
  PENDING_FEEDBACK: 0,
  REVIEWED: 1,
  RESOLVED: 2,
};

export const EventLogLevel = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const AIAgentStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
  TRAINING: 3,
};

export const AIAgentType = {
  SUPPORT: "support",
  ANALYTICS: "analytics",
  MAINTENANCE: "maintenance",
  OPTIMIZATION: "optimization",
  SECURITY: "security",
  ALERT: "alert",
};

export const AIAgentModel = {
  GPT_4O: "gpt-4o",
  DEEPSEEK_CHAT: "deepseek-chat",
  QWEN_MAX: "qwen-max",
  QWEN_PLUS: "qwen-plus",
};

export const FeedbackType = {
  NONE: 0,
  POSITIVE: 1,
  NEGATIVE: 2,
};

/**
 * 将枚举对象转换为下拉选项
 * @param {*} enumObj
 * @returns
 */
export function enumToOptions(enumObj) {
  const map = [];
  for (const key of Object.keys(enumObj)) {
    map.push({
      name: snakeToNormal(key),
      id: enumObj[key], // 不再强制转 Number
    });
  }
  return map;
}

/**
 * 将枚举值转换为标签
 * @param {*} enumObj
 * @param {*} value
 * @returns
 */
export function enumValueToLabel(enumObj, value) {
  const entry = Object.entries(enumObj).find(([, val]) => val === value);
  return entry ? snakeToNormal(entry[0]) : "--";
}
